<template>
    <div>
        <v-row>
            <v-col>
                <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
                    slider-color="#ffbc00">
                    <v-tab class="font-weight-black">Relaci&oacute;n de Becados</v-tab>
                    <v-tab class="font-weight-black">Provisiones</v-tab>
                    <v-tab class="font-weight-black">Otras Deudas</v-tab>
                    <v-tab class="font-weight-black">Deudas al Banco</v-tab>
                    <v-tab class="font-weight-black">Boletas en Lotes</v-tab>
                    <v-tab class="font-weight-black">Pagos Pendientes</v-tab>
                    <v-tab class="font-weight-black">Pagos Realizados</v-tab>
                    <v-tab class="font-weight-black">Estado de Cobros</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <becadoComp class="py-4"></becadoComp>
                    </v-tab-item>

                    <v-tab-item>
                        <provisionComp class="py-4"></provisionComp>
                    </v-tab-item>

                    <v-tab-item>
                        <otraDeudaComp class="py-4"></otraDeudaComp>
                    </v-tab-item>

                    <v-tab-item>
                        <deudaBancoComp class="py-4"></deudaBancoComp>
                    </v-tab-item>

                    <v-tab-item>
                        <boletaLoteComp class="py-4"></boletaLoteComp>
                    </v-tab-item>

                    <v-tab-item>
                        <pagoPendienteComp class="py-4"></pagoPendienteComp>
                    </v-tab-item>

                    <v-tab-item>
                        <pagoRealizadoComp class="py-4"></pagoRealizadoComp>
                    </v-tab-item>

                    <v-tab-item>
                        <estadoCobroComp class="py-4"></estadoCobroComp>
                    </v-tab-item>
                </v-tabs-items>


            </v-col>
        </v-row>
    </div>
</template>



<script>

import ProvisionComp from './components/ProvisionComp.vue'
import BecadoComp from './components/BecadoComp.vue'
import OtraDeudaComp from './components/OtraDeudaComp.vue'
import DeudaBancoComp from './components/DeudaBancoComp.vue'
import BoletaLoteComp from './components/BoletaLoteComp.vue'
import PagoPendienteComp from './components/PagoPendienteComp.vue'
import PagoRealizadoComp from './components/PagoRealizadoComp.vue'
import EstadoCobroComp from './components/EstadoCobroComp.vue'

export default {
    components: {
        provisionComp: ProvisionComp,
        becadoComp: BecadoComp,
        otraDeudaComp: OtraDeudaComp,
        deudaBancoComp: DeudaBancoComp,
        boletaLoteComp: BoletaLoteComp,
        pagoPendienteComp: PagoPendienteComp,
        pagoRealizadoComp: PagoRealizadoComp,
        estadoCobroComp: EstadoCobroComp,
    },
    data() {
        return {
            tab: 0,
        }
    },
}

</script>